import React, {Fragment} from 'react';

import cs from 'classnames';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {PopoverHeading} from 'app/general/overlays';
import StateButton from 'app/general/widgets/StateButton';
import {useArticles, useDeleteArticle} from 'app/kbs/api';
import {gt} from 'app/utils/i18n';

interface Props {
  onSuccess: () => Promise<any>;
  contentType;
  objectId;
}

export const KBSelectedArticleList = ({
  onSuccess,
  contentType,
  objectId,
}: Props) => {
  const {data: articleData} = useArticles({
    document_object_id: objectId,
    document_content_type: contentType,
  });

  const [deleteArticle] = useDeleteArticle();

  function doRemoveFromFolder(id: string | number): Promise<unknown> {
    return deleteArticle({id}).unwrap().then(onSuccess);
  }

  return articleData?.results != null && articleData?.results.length > 0 ? (
    <Fragment>
      <PopoverHeading className="popover-header">
        {gt('Knowledge Bases')}
      </PopoverHeading>
      <ul
        className="list-group list-group-flush flex-grow-1 flex-shrink-0 overflow-auto"
        style={{
          maxHeight: 'calc(60vh - 230px)',
        }}
      >
        {articleData?.results.map((article) => (
          <li
            key={article.id}
            style={{
              borderColor: 'rgba(255,255,255,0.5)',
            }}
            className={cs(
              'active list-group-item py-1 d-flex align-items-center ' +
                'justify-content-between pr-0'
            )}
          >
            <div className="text-truncate">
              <span className="d-block text-truncate">
                {article.category.name}
              </span>
              <small className="block text-truncate">
                {article.knowledgebase.name}
              </small>
            </div>
            <LazyTooltip
              placement="left"
              tooltip={gt(`Remove from this category`)}
            >
              <StateButton
                className="btn-sm btn-link py-1 px-3 text-white"
                onClick={() =>
                  article.id
                    ? doRemoveFromFolder(article.id)
                    : Promise.resolve()
                }
              >
                <i className="fa fa-fw fa-times" />
              </StateButton>
            </LazyTooltip>
          </li>
        ))}
      </ul>
    </Fragment>
  ) : null;
};
